'use client';

import type {FC} from 'react';
import {useCallback, useEffect} from 'react';
import {useState} from 'react';
import clsx from 'clsx';
import {useRouter} from 'next/navigation';

import {i18n} from '@/utils/i18n';

import {Spinner} from '../spinner';

export const PreviewBar: FC = () => {
	const router = useRouter();
	const [isExitingPreview, setIsExitingPreview] = useState(false);
	const [isIframe, setIsIframe] = useState(false);

	const handleClose = useCallback(async () => {
		setIsExitingPreview(true);

		try {
			await fetch('/api/draft-disable');
			// Every route is dynamic (the root layout reads draftMode()), and
			// dynamic routes are never reused from the client router cache, so
			// this renders the published front page without a refresh().
			router.replace('/');
		} catch (error) {
			console.error(error);
			setIsExitingPreview(false);
		}
	}, [router]);

	useEffect(() => {
		if (typeof window !== 'undefined') {
			// FIXME: fix react hook error
			// eslint-disable-next-line react-hooks/set-state-in-effect
			setIsIframe(window.self !== window.top);
		}
	}, []);

	// Inside the Studio preview pane the bar is just noise; the editor knows
	// they are previewing. Outside it, it is the only way to leave draft mode.
	if (isIframe) {
		return null;
	}

	return (
		<div
			className={clsx(
				'bg-forestGreen-700',
				'flex',
				'flex-col',
				'items-center',
				'gap-2',
				'p-2',
				'px-4',
				'text-center',
				'!text-[14px]',
				'text-white',
				'md:flex-row',
				'md:flex-wrap',
				'md:justify-between',
			)}
		>
			<strong className={clsx('block')}>{i18n.preview.active}</strong>
			{i18n.preview.activeDescription}
			{!isExitingPreview && (
				<button
					onClick={handleClose}
					className={clsx(
						'border',
						'px-4',
						'py-1',
						'hover:bg-black/40',
						'hover:text-white',
						'focus:bg-black/40',
						'focus:text-white',
					)}
				>
					{i18n.preview.exit}
				</button>
			)}
			{isExitingPreview && <Spinner />}
		</div>
	);
};
